import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';
import TokenService from '../services/TokenService'
import Grid from '@mui/material/Grid';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AlertDialog from './Modals/AlertDialog'
import Button from '@mui/material/Button';
import BusinessCard from './Marketing/BusinessCard';
import Flyer from './Marketing/Flyer';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import LanguageIcon from '@mui/icons-material/Language';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import ShareIcon from '@mui/icons-material/Share';

function Marketing() {
    const [isFetching, setIsFetching] = useState(true);
    const documentLoaded = useRef(false);
    const [userLevel, setUserLevel] = useState(null);
    const prevUserLevel = useRef(false);
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });

    const [alertDialog, setAlertDialog] = useState({
        show: false,
        title: '',
        message: '',
        closeButton: '',
    });
   
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();


    useEffect(() => {
//        loadAccount(); // only called once
    }, []);

    



    return (
        <>

         
            <div style={{ width: '100%', height: '200px', backgroundColor: 'var(--sipzee-yellow-3)', display: 'flex', alignItems: 'center' }}>

                <div style={{ alignSelf: 'center' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', padding: '25px' }}>
                        <div className='Page-Header' style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <PermMediaIcon style={{ marginRight: '10px' }} sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} />
                            <div style={{}}>Marketing Material</div>
                        </div>
                        <div style={{ fontSize: '16pt', display: 'flex', alignSelf: 'center', justifyContent: 'flex-start' }}>
                            Download or request prints of Sipzee marketing material
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', padding: '10px', flexDirection: 'column', flexWrap: 'wrap' }}>

                <div style={{ marginTop: '15px', maxWidth: '350px', alignSelf: 'center', textAlign:'left' }}>
                    <LanguageIcon sx={{ color: 'var(--sipzee-green)', position:'relative', top:'5px'}} /> Our ads attempt to support all Sipzee Recyclers, but you can help grow your own service as well.
                </div>


                <div style={{ marginTop: '15px', maxWidth: '350px', alignSelf: 'center', textAlign: 'left' }}>
                    <Diversity1Icon sx={{ color: 'var(--sipzee-red)', position: 'relative', top: '5px' }} /> Sipzee is all about supporting local communities. And who knows your community best but you?
                </div>

                <div style={{ marginTop: '15px', maxWidth: '350px', alignSelf: 'center', textAlign: 'left' }}>
                    <QrCode2Icon sx={{ color: 'var(--sipzee-gray)', position: 'relative', top: '5px' }} /> Below you can find flyers or cards customized to you. If a customer scans the QR code, they will be able to request you as their preferred recycler.
                    You'll then receive a notification about their pickup request and have 24 hours to schedule it. If you enjoyed a particular pickup, feel free to leave your card for the customer to encourage repeat business. These tools are intended to serve as an aid to help grow your local recycling opportunites!


                </div>

                <div style={{ marginTop: '15px', maxWidth: '350px', alignSelf: 'center', textAlign: 'left' }}>
                    <ShareIcon sx={{ color: 'var(--sipzee-yellow)', position: 'relative', top: '5px' }} /> You can download digitial versions to share electronically, print them yourself, or request that we have them printed and mailed to you.
                </div>
               
                <div style={{marginTop:'15px', maxWidth:'350px', alignSelf:'center'} }>
                    <BusinessCard flyerName='BusinessCard1' />
                </div>

                <div style={{ marginTop: '15px', maxWidth: '350px', alignSelf: 'center' }}>
                    <Flyer flyerName='Flyer1' displayName='Flyer for Customers' />
                </div>

                <div style={{ marginTop: '15px', maxWidth: '350px', alignSelf: 'center' }}>
                    <Flyer flyerName='Flyer2' displayName='Flyer for Charities and Fundrasiers' />
                </div>

            </div>
           
        </>
    );
}

export default Marketing;